import { useState } from "react";
import MobileMenu from "../../sections/mobileMenu/mobileMenu";
import Header from "../../sections/header/header";
import UserProfile from "../../sections/userProfile/userProfile";
import Footer from "../../sections/footer/footer";
import PopupForm from "../../sections/popupForm/popupForm";
import CallbackForm from "../../sections/callbackForm/callbackForm";

const Profile = () => {
    const [message, setMessage] = useState("");

    return (
        <>
            <MobileMenu/>
            <div className="page page--index page--cabinet">
                <Header/>
                <main className="page__main">
                    <UserProfile message={message} setMessage={setMessage} />
                </main>
                <Footer/>
                <PopupForm setMessage={setMessage} />
                <CallbackForm/>
            </div>
        </>
    );
};

export default Profile;